import React from 'react';
import logo from '../../images/logo.png';
import './Header.css';
import { Navbar, Nav, FormControl, Form, Button } from 'react-bootstrap';

const Header = () => {
    return (
        <div className="header">
            <Navbar bg="dark" variant="dark">
            <img src={logo} alt="" />
                <Nav className="mr-auto">
                    <Nav.Link className="text-white" href="#players">Players</Nav.Link>
                    <Nav.Link className="text-white" href="#member">Member</Nav.Link>
                    <Nav.Link className="text-white" href="#match">Match</Nav.Link>
                </Nav>
                <Form inline>
                    <FormControl type="text" placeholder="Search" className="mr-sm-2" />
                    <Button variant="outline-info">Search</Button>
                </Form>
            </Navbar>
        </div>
    );
};

export default Header;